var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "18", height: "20", viewBox: "0 0 18 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M6 3a3 3 0 1 1 6 0h4a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4zm3-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM2 12.46V14h3.11l1.51-2.85.76 5.77 3.69-4.71L12.89 14H16v-1.54h-2.47l-2.6-2.6-2.49 3.19-.94-6.97-3.33 6.38H2z", fill: "#2D9F86" })
  );
});


// WEBPACK FOOTER //
// ./src/static/images/icons/Clinician.svg